<template>
  <el-container class="main-content">
    <el-aside class="left-panel right-panel" width="840px">
      <resumeViewInfo v-if="resumeId" :resumeId="resumeId"></resumeViewInfo>
      <div v-else-if="errMsg">
        <div style="font-size: 32px; padding: 30px 0 0">
          {{errMsg}}
        </div>
        <div style="padding: 10px 0 10px">
          关注公众号“乐跳会员”，查看更多人才
        </div>
        <img :src="require('~/assets/images/hrQrCode.png')" width="188" />
        <div style="padding: 10px 0 30px">微信“扫一扫”上方二维码</div>
      </div>
    </el-aside>
    <el-main class="right-panel" style="text-align:center; padding-top: 30px">
      <div style="position:fixed; height:212px; width: 340px; background-color: #fff;">
        <img :src="meQrcodeUrl" style="padding: 10px 0 0" width="120" />
        <div style="margin: 0 auto; padding: 10px 0 30px; width: 168px;">
          微信“
          <transition v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:leave="leave">
            <span v-if="showChat">扫一扫</span>
          </transition>
          ”二维码，和<span style="margin: 0 4px;">{{meName}}</span>
          <span>聊一聊</span>
        </div>
      </div>
      <div class="advantage-panel">
        <span class="advantage-title">选择乐跳网的优势</span>
        <ul class="advantage-list">
          <li>专属顾问一对一服务：专属顾问全程线下联络推进，大大减少招聘负责人时间和精力消耗。</li>
          <li>招聘启动快：成为乐跳企业会员，提交职位需求，立即获得候选人简历，无需等待，无需招聘网发布职位之后的大量筛选。</li>
          <li>推荐全程免费：华东地区上万家企业会员都知道，录用乐跳推荐的候选人不用支付任何猎头费用。当今企业招聘难度越来越大，招聘成本越来越高，乐跳的专业服务是他们的最佳选择。</li>
          <li>面试到访率高：乐跳充分征求HR和会员的意向，候选人面试出勤率高（超过80%），面试出状况的情况少。</li>
          <li>OFFER分歧少：专业老师居间协调，大大减少误解和分歧，让HR选中的每一位候选人，都能顺利入职。</li>
          <li>录用后稳定性强：候选人需支付成功费用，自然选择慎重，录用后稳定性很高，不易反水。</li>
        </ul>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import Velocity from 'velocity-animate';
  import {
    getResumeInfoByCode,
    getMeQrCode
  } from '~/api/market';
  import resumeViewInfo from '~/components/ResumeViewInfo';
  export default {
    components: {
      resumeViewInfo
    },
    data() {
      return {
        meDataId: parseInt(this.$route.query.id),
        code: this.$route.query.code,
        resumeId: 0,
        errMsg: '',
        meQrcodeUrl: '',
        meName: '',
        showChat: true,
        fadeOutDuration: 1000,
      };
    },
    created() {
      if (!this.meDataId) {
        this.$message.error('未找到简历');
      }
      this.getResumeId();
      this.getMeQr();
    },
    mounted() {
      this.showChat = false;
    },
    methods: {
      beforeEnter: function (el) {
        el.style.opacity = 0.2;
      },
      enter: function (el, done) {
        var vm = this;
        Velocity(el, {
          opacity: 1
        }, {
          duration: this.fadeInDuration,
          complete: function () {
            done();
            if (!vm.stop) vm.showChat = false;
          }
        });
      },
      leave: function (el, done) {
        var vm = this;
        Velocity(el, {
          opacity: 0.2
        }, {
          duration: this.fadeOutDuration,
          complete: function () {
            done();
            vm.showChat = true;
          }
        });
      },
      getResumeId() {
        var params = {
          meDataId: this.meDataId,
          code: this.code
        };
        getResumeInfoByCode(params).then(m => {
          if (m.errcode == 0) {
            var info = m.data;
            this.resumeId = info.resumeId;
            this.meName = info.meName;
          } else {
            this.errMsg = m.errmsg;
          }
        });
      },
      getMeQr() {
        var params = {
          meDataId: this.meDataId,
          code: this.code
        };
        getMeQrCode(params).then(m => {
          if (m.errcode === 0) {
            this.meQrcodeUrl = m.data;
          }
        });
      }
    }
  };
</script>

<style scoped>
</style>